import { Construction } from "lucide-react";
import { AdminLayout } from "./AdminLayout";
import { ADMIN } from "@/constants/testIds";

export default function AdminSettingsPage() {
  return (
    <AdminLayout>
      <section className="space-y-6">
        <header className="space-y-1">
          <p className="text-xs font-medium uppercase tracking-widest text-intel-800">
            الإعدادات
          </p>
          <h2 className="text-2xl font-semibold tracking-tight text-ink-900 sm:text-3xl">
            إعدادات لوحة الإدارة
          </h2>
          <p className="max-w-2xl text-sm leading-relaxed text-ink-500">
            سيتم تفعيل خيارات الحساب، الصلاحيات، وقواعد التحرير في تحديث لاحق.
          </p>
        </header>

        <div
          data-testid={ADMIN.settingsPlaceholder}
          className="rounded-xl border border-dashed border-surface-200 bg-white px-6 py-16 text-center"
        >
          <div className="mx-auto inline-flex h-12 w-12 items-center justify-center rounded-full bg-intel-50 text-intel-800">
            <Construction className="h-6 w-6" strokeWidth={1.75} />
          </div>
          <h3 className="mt-4 text-base font-semibold text-ink-900">
            هذه الصفحة قيد الإعداد
          </h3>
          <p className="mx-auto mt-2 max-w-md text-sm text-ink-500">
            نعمل على واجهات الصلاحيات وإدارة المستخدمين وسير عمل التحرير. سنُطلقها فور جاهزيتها.
          </p>
        </div>
      </section>
    </AdminLayout>
  );
}
